import { Link } from 'react-router-dom';
import { mangaWorks } from '@/mocks/manga';
import MangaCard from '@/components/feature/MangaCard';

export default function HotRanking() {
  const ranked = [...mangaWorks].sort((a, b) => b.views - a.views).slice(0, 8);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100/70" id="ranking">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
              热门排行
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              根据阅读量实时更新的热门作品榜单
            </p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {ranked.map((work, index) => (
            <div key={work.id} className="relative">
              {index < 3 && (
                <div className="absolute -top-2 -left-2 z-10 w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-lg bg-accent-500 text-white text-xs font-bold">
                  {index + 1}
                </div>
              )}
              <MangaCard {...work} />
            </div>
          ))}
        </div>
        <div className="mt-8 flex justify-center sm:hidden">
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-500 font-medium whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}